<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" max-width="600px" overlay-opacity="0.9" v-if="$vuetify.breakpoint.mdAndUp">
      <v-card class="pb-4">
        <v-card-title>
          <div class="text-left">
            <div class="title">Elige dónde recibir tu compra</div>
            <div class="text--secondary light-text">Podrás ver costos y tiempos de entrega precisos en todo lo que busques.</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn class="mt-n6" icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="showDeliveryTypes">
          <div class="ubication-container">
            <div class="ubication-icon-container">
              <v-icon color="blue">location_on</v-icon>
            </div>
            <div class="ubication-selected-container">
              <div>{{ shippingInput.city.name }}, {{ shippingInput.region.name }}</div>
              <div><a class="blue--text text--darken-3 link" @click="changeLocation">Elegir otra ubicación</a></div>
            </div>
          </div>

          <div class="delivery-type-continer" v-for="(deliveryType, index) in deliveryTypes" :key="'delivery_type_' + index">
            <div class="delivery-type-title">
              {{getDeliveryTypeName(deliveryType.delivery_type)}}
            </div>
            <div class="delivery-type-description-continer" v-if="deliveryType.delivery_type === 'standard-delivery'">
              <div>
                <div>Llega el {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }} a tu dirección</div>
                <div class="text--secondary light-text">Comprando el {{ dateFormat(new Date(), 'D MMM YYYY') }}</div>
              </div>
              <div class="delivery-type-description-cost">
                <div class="green--text text--darken-2" v-if="deliveryIsFree(deliveryType, totalValue)">Gratis</div>
                <div v-else>{{ currency(deliveryType.cost) }}</div>
              </div>
            </div>
            <div class="delivery-type-description-continer" v-else-if="deliveryType.delivery_type === 'cash-on-delivery'">
              <div>
                <div>Llega el {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }} a tu dirección</div>
                <div class="text--secondary light-text">Comprando el {{ dateFormat(new Date(), 'D MMM YYYY') }}</div>
              </div>
              <div class="delivery-type-description-cost">
                <div class="green--text text--darken-2" v-if="deliveryIsFree(deliveryType, totalValue)">Gratis</div>
                <div v-else>{{ currency(deliveryType.cost) }}</div>
              </div>
            </div>
            <div class="delivery-type-description-continer" v-else>
              <div>
                <div>Retira a partir del {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }} en la tienda</div>
                <div class="text--secondary light-text">{{ ubication.city }}, {{ ubication.departament }}, de {{ schedule }} hasta la {{ closeTime }} p.m</div>
              </div>
              <div class="delivery-type-description-cost">
                <div class="green--text text--darken-2" v-if="deliveryIsFree(deliveryType, totalValue)">Gratis</div>
                <div v-else>{{ currency(deliveryType.cost) }}</div>
              </div>
            </div>
            <v-divider></v-divider>
          </div>
          <div class="shpping-threshold text--secondary light-text">
            Envíos gratis para compras mayores a {{ currency(freeShippingThreshold) }}, no incluye envió contra entrega
          </div>
        </v-card-text>
        <v-card-text v-else>
          <shipping-form @selectedLocation="selectedLocation" :totalValue="totalValue"></shipping-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isOpen" fullscreen hide-overlay transition="dialog-bottom-transition" v-else>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Elige dónde recibir tu compra</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
        <v-row justify="start" no-gutters>
          <v-col sm="10" cols="12">
            <div class="mt-2 text--secondary light-text-mobile">Podrás ver costos y tiempos de entrega precisos en todo lo que busques.</div>
          </v-col>
        </v-row>
        </v-card-title>
        <v-card-text v-if="showDeliveryTypes">
          <div class="ubication-container">
            <div class="ubication-icon-container">
              <v-icon color="blue">location_on</v-icon>
            </div>
            <div class="ubication-selected-container">
              <div>{{ shippingInput.city.name }}, {{ shippingInput.region.name }}</div>
              <div><a class="blue--text text--darken-3 link" @click="changeLocation">Elegir otra ubicación</a></div>
            </div>
          </div>

          <div class="delivery-type-continer" v-for="(deliveryType, index) in deliveryTypes" :key="'delivery_type_' + index">
            <div class="delivery-type-title">
              {{getDeliveryTypeName(deliveryType.delivery_type)}}
            </div>
            <div class="delivery-type-description-continer" v-if="deliveryType.delivery_type === 'standard-delivery'">
              <div>
                <div>Llega el {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }} a tu dirección</div>
                <div class="text--secondary light-text">Comprando el {{ dateFormat(new Date(), 'D MMM YYYY') }}</div>
              </div>
              <div class="delivery-type-description-cost">
                <div class="green--text text--darken-2" v-if="deliveryIsFree(deliveryType, totalValue)">Gratis</div>
                <div v-else>{{ currency(deliveryType.cost) }}</div>
              </div>
            </div>
            <div class="delivery-type-description-continer" v-else-if="deliveryType.delivery_type === 'cash-on-delivery'">
              <div>
                <div>Llega el {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }} a tu dirección</div>
                <div class="text--secondary light-text">Comprando el {{ dateFormat(new Date(), 'D MMM YYYY') }}</div>
              </div>
              <div class="delivery-type-description-cost">
                <div class="green--text text--darken-2" v-if="deliveryIsFree(deliveryType, totalValue)">Gratis</div>
                <div v-else>{{ currency(deliveryType.cost) }}</div>
              </div>
            </div>
            <div class="delivery-type-description-continer" v-else>
              <div>
                <div>Retira a partir del {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }} en la tienda</div>
                <div class="text--secondary light-text">{{ ubication.city }}, {{ ubication.departament }}, de {{ schedule }} hasta la {{ closeTime }} p.m</div>
              </div>
              <div class="delivery-type-description-cost">
                <div class="green--text text--darken-2" v-if="deliveryIsFree(deliveryType, totalValue)">Gratis</div>
                <div v-else>{{ currency(deliveryType.cost) }}</div>
              </div>
            </div>
            <v-divider></v-divider>
          </div>
          <div class="shpping-threshold text--secondary light-text">
            Envíos gratis para compras mayores a {{ currency(freeShippingThreshold) }}, no incluye envió contra entrega
          </div>
        </v-card-text>
        <v-card-text v-else>
          <shipping-form @selectedLocation="selectedLocation" :totalValue="getProductMinPrice"></shipping-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { UBICATION, SCHEDULE, CLOSE_TIME } from '@/config/local-info'
import { FREE_SHIPPING_THRESHOLD, getDeliveryTypeName, deliveryIsFree } from '@/shared/delivery'

import { addDaysToCurrentDate } from '@/shared/date'
import { dateFormat, currency } from '@/shared/format'
import ShippingForm from '@/components/Shipping/ShippingForm'

export default {
  name: 'ShippingModal',
  components: {
    ShippingForm
  },
  props: {
    totalValue: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      getDeliveryTypeName,
      deliveryIsFree,
      addDaysToCurrentDate,
      dateFormat,
      currency,
      freeShippingThreshold: FREE_SHIPPING_THRESHOLD,
      ubication: UBICATION,
      schedule: SCHEDULE,
      closeTime: CLOSE_TIME,
      showDeliveryTypes: false,
      isOpen: false
    }
  },
  computed: {
    ...mapState('shipping', ['shippingInfo', 'shippingInput', 'deliveryTypes']),
    ...mapGetters('product', ['getProductMinPrice'])
  },
  methods: {
    openModal () {
      this.isOpen = true
    },
    changeLocation () {
      this.showDeliveryTypes = false
    },
    selectedLocation () {
      this.showDeliveryTypes = true
    },
    closeModal () {
      this.showDeliveryTypes = !!this.shippingInfo && !!this.shippingInput
      this.isOpen = false
    }
  },
  mounted () {
    this.showDeliveryTypes = !!this.shippingInfo && !!this.shippingInput
  }
}
</script>

<style scoped>
  .light-text{
    font-size: 13px;
    color: #666;
    opacity: 0.7;
    line-height: 20px;
  }
  .light-text-mobile{
    font-size: 15px;
    color: #666;
    opacity: 0.7;
    line-height: 20px;
  }
  .ubication-container {
    background: rgba(0,0,0,.04);
    border-radius: 6px;
    padding: 16px 16px 16px 6px;
    margin-top: 8px;
    margin-bottom: 16px;
    text-align: left;
  }
  .ubication-icon-container {
    display: inline-flex;
    padding-left: 8px;
    padding-right: 12px;
  }
  .ubication-selected-container {
    display: inline-block;
  }
  .delivery-type-title {
    font-size: 18px;
    font-weight: 500;
    margin-top: 24px;
  }
  .delivery-type-continer {
    color: #000000DE;
    text-align: left;
  }
  .delivery-type-description-continer {
    display: flex;
    margin-top:14px;
    margin-bottom:20px;
  }
  .delivery-type-description-cost {
    flex: 1;
    text-align: right;
    padding-left: 16px;
    font-size: 16px;
  }
  .shpping-threshold {
    text-align: left;
    padding-top: 16px;
    margin-bottom: -10px;
  }
</style>
